<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
        <el-form-item label="积分启用：" prop="integralStatus">
          <el-radio-group v-model="ruleForm.integralStatus">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="积分兑换比例：" prop="integralExchangeNum">
          <el-input style="width: 424px;" v-model="ruleForm.integralExchangeNum" placeholder="请输入兑换的金额"></el-input>
          <div class="mt-system-warm">1积分抵多少金额</div>
        </el-form-item>
        <el-form-item label="下单赠送积分比例：" prop="integralGiveNum">
          <el-input style="width: 424px;" v-model="ruleForm.integralGiveNum" placeholder="请输入下单赠送积分的数量"></el-input>
          <div class="mt-system-warm">实际支付1元赠送多少积分</div>
        </el-form-item>
        <el-form-item label="签到积分：" prop="integralSignNum">
          <el-input style="width: 424px;" v-model="ruleForm.integralSignNum" placeholder="请输入签到积分的数量"></el-input>
        </el-form-item>
        <el-form-item label="积分签到说明：" prop="integralSignDesc">
          <editor :value="ruleForm.integralSignDesc" :height="350" v-model="ruleForm.integralSignDesc"></editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { fetchIntegralConfigDetail, saveOrUpdateIntegralConfig } from '@/api/integral'
import Editor from '@/components/Editor.vue'
export default {
  name: 'IntegralConfig',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      ruleForm: {
        integralStatus:'',
        integralExchangeNum:'',
        integralGiveNum:'',
        integralSignNum:'',
        integralSignDesc:''
      },
      rules: {
        integralStatus: [
          { required: true, message: '请选择是否开启积分', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    fetchIntegralConfigDetail({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.ruleForm = data;
        }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let ruleForm = that.ruleForm
      if(ruleForm.integralStatus === ''){
        this.$message.error('请选择是否开启积分')
        return false
      }
      that.fullscreenLoading = true
      saveOrUpdateIntegralConfig({integralStatus:ruleForm.integralStatus,integralExchangeNum:ruleForm.integralExchangeNum,integralGiveNum:ruleForm.integralGiveNum,integralSignNum:ruleForm.integralSignNum,integralSignDesc:ruleForm.integralSignDesc}).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              // that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/integralMall/Config.vue